import { render } from "./submitRate.vue?vue&type=template&id=fd028cc0&scoped=true"
import script from "./submitRate.js?vue&type=script&lang=js"
export * from "./submitRate.js?vue&type=script&lang=js"

import "./submitRate.vue?vue&type=style&index=0&id=fd028cc0&scoped=true&lang=scss"

import exportComponent from "/home/ec2-user/src/FVC.frontend/Public/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd028cc0"]])

export default __exports__